import Script from 'next/script';
export const OptimizelyScript = () => {
  return (
    <Script
      id='optimizely-script-fortune'
      src='https://cdn.optimizely.com/js/5509364224622592.js'
      strategy='afterInteractive'
    />
  );
};
